// extracted by mini-css-extract-plugin
export var columnList = "_fe-0";